module.exports = __webpack_public_path__ + "img/deaf.0a35e68b.svg";